<script setup>

const props = defineProps({
    headerClass: {
        type: String,
    },
    footerClass: {
        type: String,
    },
    contentClass: {
        type: String,
    },
    cardClass: {
        type: String,
    }
})
</script>

<style>

</style>

<template>
    <div class="relative rounded-xl border border-solid border-[#EAECF0] p-6 flex flex-col" :class="cardClass">
        <div :class="props.headerClass" v-if="$slots.header">
            <slot name="header"></slot>
        </div>
        <div :class="props.contentClass">
            <slot></slot>
        </div>
        <div :class="props.footerClass" v-if="$slots.footer">
            <slot name="footer"></slot>
        </div>
    </div>
</template>
